import { set } from "dot-prop-immutable";

const THINK_GREEN_SET_PARAMETER = "THINK_GREEN_SET_PARAMETER";

export const setParameter = (name, value) => ({
	type: THINK_GREEN_SET_PARAMETER,
	name, value
});

const initial_state = {
	waermerueckgewinnung: {
		parameter: {
			rueckfuehrungsIndex: 0,
			heizmaterialIndex: 0,
			nutzungszeitraumWRG_percent: 0.8,
			heizungWirkungsgrad_percent: 0.75,
			kaltesWasserEin_degC: 20,
			warmesWasserAus_degC: 60
		}
	}
};

export const thinkGreenReducer = (state = initial_state, action) => {
	switch (action.type) {
	case THINK_GREEN_SET_PARAMETER:
		return set(state, "waermerueckgewinnung.parameter." + action.name, action.value);
	default:
		return state;
	}
};
